<div>
    <!--[if lt IE 8]>
    <p class="browsehappy">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your browser</a>
        to improve your experience.</p>
    <![endif]-->

    <div *ngIf="!userHasPermission('SMR_USER')">
        <div id="fullscreenloaderoverlay" style="zoom: 1;">
        </div>
        <div id="fullscreenloadermessage" class="panel panel-default">
            <div class="panel-body">
                <div class="text-centered">
                    <h5>Loading application...</h5>
                </div>
            </div>
        </div>
    </div>

    <!-- Timeout Warning Dialog TODO: replace with NG Idle-->
<!--    <div data-backdrop="static"-->
<!--         class="modal fade" role="dialog" aria-hidden="true">-->
<!--        <div class="modal-dialog">-->
<!--            <div class="modal-content">-->
<!--                <div class="modal-header">-->
<!--                    <button type="button" class="close" (click)="sessionExpirationCancel()">&times;</button>-->
<!--                    <b>Inactive Session Warning</b>-->
<!--                </div>-->
<!--                <div class="modal-body modal-body-touch">-->
<!--                    <div>-->
<!--                        {{sessionWarningMessage}}-->
<!--                    </div>-->
<!--                    <br>-->
<!--                    <div class="text-center">-->
<!--                        You will be logged out automatically in:-->
<!--                        <h1>{{timeoutRemaining}}</h1>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; /.modal-content &ndash;&gt;-->
<!--    </div>-->
    <!-- /.modal-dialog -->
    <!-- End Timeout Warning Dialog -->

    <div class="navbar navbar-dark navbar-expand-lg py-0 sticky-top d-print-none mb-3"
         [ngClass]="themeName" role="navigation">
        <div class="container-fluid" style="height: 59px;">
            <a class="navbar-brand" href="#/router">
                <img src="images/oa_white_2.png" style="width:35px;height:auto">
                <h5 style="margin-top:7px;float:right">&nbsp;Objective Arts</h5>
            </a>
            <button class="navbar-toggler bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#top-navbar" aria-controls="top-navbar" aria-expanded="false" aria-label="Toggle Top Navbar">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse h-100" id="top-navbar-ROUTER" *ngIf="isOnDashboardRouter">
                <ul class="navbar-nav me-auto my-lg-0 navbar-nav-scroll h-100">
                    <li class="nav-item mx-2">
                        <a class="nav-link h-100 align-content-center" role="button" (click)="openToDoItemList()">
                            <div style="display: flex; flex-direction: row; height: 100%; margin-top: 9px;">
                                <div style="">ToDo&nbsp;&nbsp;</div>
                                <span style="margin-bottom: 20px;" class="badge" [ngClass]="getToDoBadgeClass()">{{aggToDoItemCount}}</span>
                            </div>
                        </a>
                    </li>
                </ul>
                <ul class="navbar-nav d-flex h-100">
                    <li class="nav-item dropdown mx-1">
                        <a class="nav-link dropdown-toggle h-100 align-content-center" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-user"></i> {{user.name}} <span class="caret"></span></a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" (click)="openChangePassword()">Change Password</a></li>
                            <li *ngIf="userHasPermission('SYSTEM_MESSAGES_ALL')" class="dropdown-divider"></li>
                            <li *ngIf="userHasPermission('SYSTEM_MESSAGES_ALL')"><a class="dropdown-item" (click)="openAddSystemMessage()">Add System Message</a></li>
                            <li *ngIf="userHasPermission('SYSTEM_MESSAGES_ALL')"><a class="dropdown-item" (click)="openShowSystemMessages()">Manage System Messages</a></li>
                        </ul>
                    </li>
                    <li class="nav-item"><a class="nav-link h-100 align-content-center" role="button" href="j_spring_security_logout">Logout</a></li>
                </ul>
            </div>

            <div class="collapse navbar-collapse h-100" id="top-navbar-SMR" *ngIf="isOnSMR">
                <ul class="navbar-nav me-auto my-lg-0 navbar-nav-scroll h-100">
                    <li class="nav-item dropdown mx-1">
                        <a class="nav-link dropdown-toggle h-100 align-content-center" role="button" data-bs-toggle="dropdown" aria-expanded="false">Clients <span class="caret"></span></a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" routerLink="data_entry/clients/list">List</a></li>
                            <li><a class="dropdown-item" routerLink="data_entry/clients/workload">Workload</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown mx-1">
                        <a class="nav-link dropdown-toggle h-100 align-content-center" role="button" data-bs-toggle="dropdown" aria-expanded="false">Assessments <span class="caret"></span></a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" routerLink="data_entry/assessments/list">List</a></li>
                            <li *ngIf="userHasPermission('ANSA_APPROVE') || userHasPermission('CANS_APPROVE')">
                                <a class="dropdown-item" routerLink="data_entry/assessments/approve">Approve</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="data_entry/assessments/myInProgress">My in progress</a></li>
                            <li><a class="dropdown-item" routerLink="data_entry/assessments/myReturned">My returned</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown mx-1"
                        *ngIf="initializationAndConfigurationService.isModuleActive('Incidents') || initializationAndConfigurationService.isModuleActive('Checklists') || initializationAndConfigurationService.isModuleActive('CANS Plan')">
                        <a class="nav-link dropdown-toggle h-100 align-content-center" role="button" data-bs-toggle="dropdown" aria-expanded="false">Lists <span class="caret"></span></a>
                        <ul class="dropdown-menu">
                            <li *ngIf="initializationAndConfigurationService.isModuleActive('Incidents')">
                                <a class="dropdown-item" routerLink="data_entry/incidents">Incidents</a>
                            </li>
                            <li *ngIf="initializationAndConfigurationService.isModuleActive('Incidents') && userHasPermission('INCIDENT_APPROVE')">
                                <a class="dropdown-item" routerLink="data_entry/incidents/approve">Incidents Approve</a>
                            </li>

                            <li class="divider"
                                *ngIf="initializationAndConfigurationService.isModuleActive('Incidents') && (initializationAndConfigurationService.isModuleActive('Checklists') || initializationAndConfigurationService.isModuleActive('CANS Plan'))">
                            </li>

                            <li *ngIf="initializationAndConfigurationService.isModuleActive('Checklists')">
                                <a class="dropdown-item" routerLink="data_entry/checklists">Checklists</a>
                            </li>

                            <li *ngIf="initializationAndConfigurationService.isModuleActive('CANS Plan')">
                                <a class="dropdown-item" routerLink="data_entry/plans">Plans</a>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item mx-2" *ngIf="initializationAndConfigurationService.isModuleActive('Dashboard') && dashboardAvailablePermissionCount == 1">
                        <a class="nav-link h-100 align-content-center" role="button" routerLink="data_entry/{{singleDashboardLink}}">{{singleDashboardDisplay}} Dashboard</a>
                    </li>

                    <li *ngIf="initializationAndConfigurationService.isModuleActive('Dashboard') && dashboardAvailablePermissionCount > 1" class="nav-item dropdown mx-1">
                        <a class="nav-link dropdown-toggle h-100 align-content-center" role="button" data-bs-toggle="dropdown" aria-expanded="false">Dashboard <span class="caret"></span></a>
                        <ul class="dropdown-menu" role="menu">
                            <li *ngFor="let dashboardItem of dashboardPermissionsArray">
                                <a *ngIf="dashboardItem.visible" class="dropdown-item" routerLink="data_entry/{{dashboardItem.link}}">{{dashboardItem.display}}</a>
                            </li>
                        </ul>
                    </li>

                    <!-- Certifications -->
                    <li *ngIf="schooxCertificationImportEnabled" class="nav-item dropdown mx-1">
                        <a class="nav-link dropdown-toggle h-100 align-content-center" role="button" data-bs-toggle="dropdown" aria-expanded="false">Certifications <span class="caret"></span></a>
                        <ul class="dropdown-menu" role="menu">
                            <li><a class="dropdown-item" routerLink="data_entry/certifications/import">Import Schoox Certificate</a></li>
                        </ul>
                    </li>

                    <!-- Reports -->
                    <li class="nav-item mx-2"><a class="nav-link h-100 align-content-center" role="button" (click)="openReport()">Reports</a></li>

                    <li class="nav-item mx-2"><a class="nav-link h-100 align-content-center" role="button" (click)="openHelp()"><span class="fa fa-circle-question"></span> Help</a></li>


                </ul>
                <ul class="navbar-nav d-flex h-100">
                    <li class="nav-item dropdown mx-1">
                        <a class="nav-link dropdown-toggle h-100 align-content-center" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-user"></i> {{user.name}} <span class="caret"></span></a>
                        <ul class="dropdown-menu">
                            <li *ngIf="userHasPermission('STAFF_VIEW')"><a class="dropdown-item" routerLink="data_entry/data-profiles">Data Profiles</a></li>
                            <li><a class="dropdown-item" (click)="openChangePassword()">Change Password</a></li>
                            <li *ngIf="userHasPermission('SYSTEM_MESSAGES_ALL')" class="dropdown-divider"></li>
                            <li *ngIf="userHasPermission('SYSTEM_MESSAGES_ALL')"><a class="dropdown-item" (click)="openAddSystemMessage()">Add System Message</a></li>
                            <li *ngIf="userHasPermission('SYSTEM_MESSAGES_ALL')"><a class="dropdown-item" (click)="openShowSystemMessages()">Manage System Messages</a></li>
                        </ul>
                    </li>
                    <li class="nav-item"><a class="nav-link h-100 align-content-center" role="button" href="j_spring_security_logout">Logout</a></li>
                </ul>
            </div>

        </div>
        <!--/.nav-collapse -->
    </div>

    <div bsModal #changePasswordModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Change Password</h4>
                    <button type="button" class="btn-close close" aria-label="close" (click)="closeChangePassword()" i18n></button>
                </div>

                <div class="modal-body">
                    <div class="alert alert-danger" *ngIf="changePasswordError">
                        {{changePasswordError}}
                    </div>
                    
                    <form role="form" #changePasswordForm="ngForm" autocomplete="off">
                        <div class="form-group my-2"
                             [ngClass]="{ 'has-error' : !oldPasswordInput.valid && oldPasswordInput.dirty }">
                            <label for="oldPassword" i18n>Old Password</label>
                            <div class="input-group">
                                <input autocomplete="off" type="password" id="oldPassword" name="oldPassword" class="form-control"
                                       placeholder="Old Password" [(ngModel)]="oldPassword" required
                                       #oldPasswordInput="ngModel" appPassword>
                            </div>
                        </div>

                        <div class="form-group my-2"
                             [ngClass]="{ 'has-error' : !newPasswordInput.valid && (newPasswordInput.dirty || newPasswordInput.touched) }">
                            <label for="newPassword" i18n>New Password</label>
                            <div class="input-group">
                                <input autocomplete="off" type="password" id="newPassword" name="newPassword" class="form-control"
                                       placeholder="New Password" required
                                       [(ngModel)]="newPassword" passwordValidator [validationRules]="passwordValidations" #newPasswordInput="ngModel" appPassword>
                            </div>
                            <p class="help-block text-danger" *ngIf="!newPasswordInput.valid && newPasswordInput.hasError('missingValue') && (newPasswordInput.dirty || newPasswordInput.touched)"
                               i18n>New Password is required.</p>
                            <p class="help-block text-danger"
                               *ngIf="!newPasswordInput.valid && newPasswordInput.hasError('invalid') && (newPasswordInput.dirty || newPasswordInput.touched)">{{newPasswordInput.errors?.['invalid']}}</p>
                        </div>

                        <div class="form-group my-2"
                             [ngClass]="{ 'has-error' : !repeatPasswordInput.valid && (repeatPasswordInput.dirty || repeatPasswordInput.touched) }">
                            <label for="repeatPassword" i18n>Repeat</label>
                            <div class="input-group">
                                <input autocomplete="off" type="password" id="repeatPassword" name="repeatPassword" class="form-control"
                                       placeholder="Repeat New Password" [(ngModel)]="repeatPassword" required passwordAgainValidator
                                       [password]="newPassword" #repeatPasswordInput="ngModel" appPassword>
                            </div>
                            <p class="help-block text-danger"
                               *ngIf="!repeatPasswordInput.valid && repeatPasswordInput.hasError('missingValue') && (repeatPasswordInput.dirty || repeatPasswordInput.touched)"
                               i18n>Repeat Password is required</p>
                            <p class="help-block text-danger"
                               *ngIf="!repeatPasswordInput.valid && repeatPasswordInput.hasError('doesNotMatch') && (repeatPasswordInput.dirty || repeatPasswordInput.touched)" i18n>Passwords do not match.</p>
                        </div>
                    </form>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" aria-label="Cancel" (click)="closeChangePassword()" i18n>Cancel</button>
                    <button type="button" class="btn btn-primary" aria-label="Save" (click)="savePassword()" [disabled]="!changePasswordForm.form.valid" i18n>Save</button>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <div bsModal #toDoModal="bs-modal" class="modal modal-lg fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">To Do List</h4>
                    <button type="button" class="btn-close close" aria-label="close" (click)="closeToDoItemList()" i18n></button>
                </div>

                <div class="modal-body">
                    <to-do-list (itemSelected)="closeToDoItemList()"></to-do-list>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" aria-label="Close" (click)="closeToDoItemList()" i18n>Close</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Add System Message Modal -->
    <div bsModal #addSystemMessageModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="addSystemMessageModalLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <app-add-system-message (closeModal)="closeAddSystemMessage()" (messageAdded)="onSystemMessageAdded()"></app-add-system-message>
            </div>
        </div>
    </div>

    <!-- Show System Messages Modal -->
    <div bsModal #showSystemMessagesModal="bs-modal" class="modal modal-lg fade" tabindex="-1" role="dialog" aria-labelledby="showSystemMessagesModalLabel"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <app-show-system-messages (closeModal)="closeShowSystemMessages()"></app-show-system-messages>
            </div>
        </div>
    </div>

    <toaster-container></toaster-container>

    <div class="h-100 container-fluid">
        <router-outlet></router-outlet>
    </div>

    <fullScreenLoader></fullScreenLoader>
</div>
